import React from "react";
import SingleProduct from "./SingleProduct";
import { useAppContext } from "../../context/appContext";

const TableProductList = () => {
    const { basket } = useAppContext();

    return (
        <div className='max-h-[60vh] overflow-y-scroll	'>
            <div className='up flex flex-1 justify-around border-b-2 border-gray-400 py-1 text-sm text-gray-500'>
                <p className='flex w-[100px] flex-[2_1_auto] pl-4 '>Product</p>
                <p className='flex w-[45px] flex-[1_1_auto] justify-end pr-2'>Qty</p>
                <p className='flex w-[45px] flex-[1_1_auto] justify-center px-2'>Each</p>
                <p className='flex w-[45px] flex-[1_1_auto] justify-center pr-4'>Total</p>
            </div>
            <div>
                {basket.basketItems.map((item, index) => {
                    return (
                        <SingleProduct
                            name={item.name}
                            quantity={item.quantity}
                            price={item.price}
                            instruction={item.instruction}
                            id={item.id}
                            key={index}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default TableProductList;
